import * as ko from "knockout";
function InstructionRecipientViewModel() {
    var self = this;
    self.InstructionRecipientId = ko.observable();
    self.InstructionId = ko.observable();
    self.Revision = ko.observable();
    self.UserId = ko.observable();
    self.OrgUnitId = ko.observable();
    self.IsRead = ko.observable();
}
;
export default InstructionRecipientViewModel;